import moment from "moment";

function DateTimeCell({ cell, row }: { cell: any; row: any }): JSX.Element {

  return (
    <td className="flex items-center min-w-[140px]">
        {moment(row.original.readyDateTime).format('MM/DD/YYYY') }
      {/* <CustomImage src={organization?.logoUrl} alt={organization.name} className="w-[27px] h-[16px] mr-1" />
      <CustomText text={organization.name} fontWeight="font-normal" /> */}
    </td>
  );
}

export default DateTimeCell;
